module.exports = __webpack_public_path__ + "img/zm.svg";